import http, { API_CORE } from '../http';

export default function DashboardAnalyticsService() {
  const getDashboardAnalytics = async (params = {}) => {
    const response = await http(API_CORE).get('/analytics/dashboard', {
      params,
    });

    return response.data;
  };

  return {
    getDashboardAnalytics: getDashboardAnalytics,
  };
}
